import { Component, ViewChild, Output, EventEmitter} from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/modal';
import {UsersModel} from "../../../models/users/users.model";

@Component({
    selector: 'user-remove-confirm',
    templateUrl: 'user-remove-confirm.template.html',
    exportAs: 'userRemoveConfirm'
})
export class UserRemoveConfirmComponent {

    model = new UsersModel();
    @ViewChild('userRemoveConfirm') public userRemoveConfirm: ModalDirective;
    @Output() remove: EventEmitter<UsersModel> = new EventEmitter<UsersModel>();

    constructor() {}

    show(model: UsersModel) {
        this.model = model;
        this.userRemoveConfirm.show();
    }
    hide() {
        this.userRemoveConfirm.hide();
    }
    removeUser() {
        this.remove.emit(this.model);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/users/user-remove-confirm/user-remove-confirm.component.ts